export var DiscountRestriction;
(function(DiscountRestriction) {
    DiscountRestriction[/**
     * Discount has no restrictions.
     */ "None"] = "None";
    DiscountRestriction[/**
     * Redemption of a [[MemberReward]] with one of the specified [[MemberRewardDiscount.rewardIds]] is required.
     */ "MemberReward"] = "MemberReward";
    DiscountRestriction[/**
     * Redemption of an [[OrderVoucher]] with one of the specified [[VoucherDiscount.voucherTypeCodes]] is required.
     */ "Voucher"] = "Voucher";
})(DiscountRestriction || (DiscountRestriction = {}));

//# sourceMappingURL=discount-restriction.js.map